import { DropdownButtonWithMenu, List, ListItemData } from 'commons/components';
import { useTranslation } from 'core/i18n';
import { useFetchOnetimeDeviceImport } from './service/hooks/use-fetch-onetime-device-import.hook';
import { useTriggerOnetimeDeviceImport } from './service/hooks/use-trigger-onetime-device-import.hook';
import { SettingsImportsButtonContent } from './components';
import FeatureFlagGuard from 'core/auth/feature-flag-guard.component';
import { DEVICE_MANAGEMENT_FEATURE_FLAG } from 'core/service/feature-flag/feature-flag.constants';

export const SettingsImportsContainer: React.FC = () => {
    const { t } = useTranslation();
    const { data, isLoading } = useFetchOnetimeDeviceImport();
    const { isLoading: isTriggering, triggerImport } = useTriggerOnetimeDeviceImport();

    const handleImportDevicesFromPocm = () => triggerImport();

    const contextMenuItems: ListItemData[] = [
        {
            id: 'import-devices-pocm',
            value: 'import-devices-pocm',
            label: t('settings.context-menu.import-devices.button'),
            onClick: handleImportDevicesFromPocm,
            disabled: isLoading || isTriggering || data?.state === 'STARTED',
            tooltipText: data?.state === 'STARTED' ? t('settings.context-menu.import-devices.in-progress') : undefined,
        },
    ];

    return (
        <FeatureFlagGuard featureFlag={DEVICE_MANAGEMENT_FEATURE_FLAG}>
            <DropdownButtonWithMenu
                id="settings-context-menu"
                buttonContent={SettingsImportsButtonContent}
                menuContent={<List items={contextMenuItems} />}
                variant="tertiary"
            />
        </FeatureFlagGuard>
    );
};
